export type { SDQuizOption, SDQuizProps } from './sd-quiz'
export { SDQuiz } from './sd-quiz'
